<template>
  <div id="app">
  	<router-view></router-view> 
		<!--<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view> 
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>-->
	</div>
</template>

<script>
export default {
   name: 'App',
  mounted() {
    // this.setHtmlSize();
    // window.onresize = () => {
    //   this.setHtmlSize();
    // };
  },
  methods: {
    /**
     * 页面适配
     */
    // setHtmlSize() {
    //   let defaultWidth = 750;
    //   let defaultFontSize = 100;
    //   let minWidth = 320;
    //   let wd = document.body.clientWidth;
    //   let fontSize;
    //   if (wd > defaultWidth) {
    //     fontSize = defaultFontSize;
    //   } else if (wd < minWidth) {
    //     fontSize = (minWidth / defaultWidth) * defaultFontSize;
    //   } else {
    //     fontSize = (wd / defaultWidth) * defaultFontSize;
    //   }
    //   document.querySelector("html").style.fontSize = fontSize + "px";
    // }
  }
};
</script>

<style>

#app {
  /* font-family: '微软雅黑','Avenir', Helvetica, Arial, sans-serif;
  font-family: 微软雅黑; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  text-align: left;
  -webkit-overflow-scrolling: touch;
  /*color: #2c3e50;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue